import { PAGINATION_ALL_ITEMS_SIZE } from '../../../../../../constants/pagination'
import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../../../../../Building'
import {
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS,
} from '../../../../Newsboard.constants'
import {
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ALL_EMPLOYEES,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS,
} from '../RecipientsField.constants'

export const AUDIENCE = [
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS,
  NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ALL_EMPLOYEES,
]

export const NON_REGISTERED_USERS = [
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS,
]

export const REGISTERED_USERS = [
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS,
  NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS,
]

export const TAG_TRANSLATION_KEYS = {
  [NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_DWELLERS]:
    'Newsboard.ToNotSignedUpDwellersTagKey',
  [NEWSBOARD_POST_AUDIENCE_TO_NOT_SIGNED_UP_LANDLORDS]:
    'Newsboard.ToNotSignedUpLandlordsTagKey',
  [NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_DWELLERS]:
    'Newsboard.ToSignedUpDwellersTagKey',
  [NEWSBOARD_POST_AUDIENCE_TO_SIGNED_UP_LANDLORDS]:
    'Newsboard.ToSignedUpLandlordsTagKey',
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_ALL_EMPLOYEES]:
    'Newsboard.AllEmployeesTagKey',
  [NEWSBOARD_POST_FORM_RECIPIENTS_FIELD_NAME_TV_SCREENS]:
    'Newsboard.TvScreensTagKey',
}

export const BUILDINGS_DWELLER_API_PARAMS = {
  ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
  page: 1,
  size: PAGINATION_ALL_ITEMS_SIZE,
}
